<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 16:28:38
 * @LastEditTime: 2020-06-08 16:41:54
 * @Description: 上传必考题目
 -->
<template>
  <div class="upload-file-wrap">
    <i-upload
      class="upload-file"
      type="drag"
      :show-upload-list="false"
      accept=".xls"
      name="file"
      :headers="{ psstoken: token }"
      :data="{ examId, paperName }"
      action="/examcentersite/paper/import/excel"
      :before-upload="requiredQuestionsBeforeUpload"
      :on-success="requiredQuestionsUploaded"
      :on-error="requiredQuestionUploadError">
      <div class="placeholder">
        <i-icon type="ios-cloud-upload" />
        <p>点击或者将文件拖曳至此处上传</p>
        <p class="tip">支持扩展名：.xls</p>
      </div>
    </i-upload>
    <p v-if="failed" class="upload-failed">{{ failed }}</p>
    <p v-if="fileName" class="upload-file-name">{{ fileName }}</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'UploadFile',
  props: {
    examId: { type: [Number, String], reuqired: true },
  },
  data() {
    return {
      failed: '',
      fileName: '',
    };
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
      paperName: 'createPaperStore/paperName',
    }),
  },
  watch: {
    examId: {
      immediate: true,
      handler(examId) {
        this.examId = examId;
      },
    },
  },
  methods: {
    ...mapActions({
      setProcessingShowState: 'pageStore/invokeSetProcessingShowState',
      setPaperId: 'createPaperStore/invokeSetPaperId',
      setPaperName: 'createPaperStore/invokeSetPaperName',
      setBigQuestions: 'createPaperStore/invokeSetBigQuestions',
    }),
    /**
     * 上传必考题之前
     */
    requiredQuestionsBeforeUpload() {
      this.setProcessingShowState({ show: true });

      this.failed = '';
      this.fileName = '';
    },
    /**
     * 必考题上传完成
     */
    requiredQuestionsUploaded(result, file) {
      if (result.code === '200') {
        alert('上传成功');

        this.failed = '';
        this.fileName = file.name;

        this.setPaperId({ paperId: result.data.paper.id });
        this.setPaperName({ paperName: result.data.paper.name });
        this.setBigQuestions({ bigQuestions: result.data.result });

        this.$emit('upload-success');
      } else {
        // eslint-disable-next-line no-lonely-if
        if (result.msg) {
          this.failed = result.msg;
        }

        this.setBigQuestions({ bigQuestions: [] });
        this.$emit('upload-failed');
      }

      this.setProcessingShowState({ show: false });
    },
    /**
     * 必考题上传失败
     */
    requiredQuestionUploadError(error, result) {
      if (result.msg) {
        this.failed = result.msg;
      }

      this.setProcessingShowState({ show: false });
    },
  },
};
</script>

<style lang="less" scoped>
.upload-file-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .upload-file {
    position: relative;
    width: 40%;
    height: 180px;

    /deep/ .ivu-upload-drag {
      width: 100%;
      height: 100%;
    }

    .placeholder {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      height: 100%;

      > i {
        margin-bottom: 8px;
        font-size: 58px;
        color: #3399ff;
      }

      > .tip {
        margin-top: 8px;
        font-size: 10px;
        opacity: .56;
      }
    }
  }

  .upload-failed {
    padding: 6px 0;
    font-size: 12px;
    color: red;
  }

  .upload-file-name {
    padding: 6px 0;
    font-size: 12px;
  }
}
</style>
